import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListMeasurementUnits = () => {
    return axios.get(`/api/SkKpi/measurementUnit/list`, { headers: authHeaderJson() } )
};

const getMeasurementUnitById = (measurementUnitId) => {
        return axios.get(`/api/SkKpi/measurementUnit/${measurementUnitId}`, { headers: authHeaderJson() } );
};

const addMeasurementUnit = (measurementUnit) => {
    return axios.post(`/api/SkKpi/measurementUnit/add/`, measurementUnit, { headers: authHeaderJson() } );
}

const addMeasurementUnitList = (measurementUnits) => {
    return axios.post(`/api/SkKpi/measurementUnit/add/list`, measurementUnits, { headers: authHeaderJson() } );
}

const saveMeasurementUnitById = (measurementUnitId, objContract) => {
    return axios.put(`/api/SkKpi/measurementUnit/${measurementUnitId}`, objContract, { headers: authHeaderJson() });
};

const deleteMeasurementUnit = (measurementUnitId) => {
    return axios.delete(`/api/SkKpi/measurementUnit/${measurementUnitId}`, { headers: authHeaderJson() });
}

export {
    getListMeasurementUnits,
    getMeasurementUnitById,
    addMeasurementUnit,
    addMeasurementUnitList,
    saveMeasurementUnitById,
    deleteMeasurementUnit
}